{
  "Approve": "Aprovar",
  "DeleteReminder": "Excluir lembrete",
  "DismissAlert": "Ignorar",
  "DismissReminder": "Ignorar lembrete",
  "EditReminder": "Editar lembrete",
  "High": "Alto",
  "Reject": "Rejeitar",
  "RemindMe15Min": "Lembrar em 15 minutos",
  "RemindMe5Min": "Lembrar em 5 minutos",
  "RemindMe60Min": "Lembrar em uma hora",
  "RemindMeTomorrow": "Lembre-me amanhã",
  "Snooze": "Lembre-me",
  "markAsRead": "Marcar como lido",
  "markAsUnread": "Marcar como não lido"
}
